import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-deployment',
  templateUrl: './our-deployment.component.html',
  styleUrls: ['./our-deployment.component.scss']
})
export class OurDeploymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
